export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Arıyorum',
  frontPageProvideTitle: 'Sunuyorum',
  frontPagePersonalCenterTitle: 'Profil',
  login: 'Giriş yap',
  home_chatWithOctopie: 'Düşüncelerin anlaşılıyor',
  home_chatNeedUnderstood: 'Düşüncelerin anlaşıldı',
  home_draftBannerTitle: 'Mesajını tamamla',
  home_draftBannerSubtitle: 'Yapay zeka mesajını senin için hazırladı — devam etmek için dokun',
  home_tabHome: 'Ana Sayfa',

  // App.vue
  appRequirementTitle: 'Her öneriye ve geri bildirime büyük önem veriyoruz',
  appRequirementBtn: 'Gönder',
  appSubmitSuccess: 'Başarıyla gönderildi, geri bildirimin için teşekkürler',
  appFeedbackLink: 'Öneri/Geri bildirim',
  mobile_banner_text: 'En iyi deneyim için uygulamamızı kullan',
  mobile_banner_btn: 'Uygulamayı al',

  // Common
  loading: 'Yükleniyor...',
  confirm: 'Onayla',
  cancel: 'İptal',
  save: 'Kaydet',
  delete: 'Sil',
  edit: 'Düzenle',
  add: 'Ekle',
  search: 'Ara',
  refresh: 'Yenile',
  change_batch: 'Karıştır',
  back: 'Geri',
  submit: 'Gönder',
  close: 'Kapat',
  ok: 'Tamam',
  yes: 'Evet',
  no: 'Hayır',
  send: 'Gönder',
  block: 'Engelle',
  more: 'Daha fazla',
  logout: 'Çıkış yap',
  settings: 'Ayarlar',
  view_guide: 'Rehbere bak',
  feedback: 'Geri bildirim',
  feedback_title: 'Geri bildirim',
  feedback_new: 'Yeni geri bildirim',
  feedback_empty: 'Henüz geri bildirim yok',
  feedback_hint: 'Fikrini söyle...',
  feedback_submit: 'Gönder',
  feedback_submit_success: 'Geri bildirim başarıyla gönderildi',
  feedback_submit_failed: 'Geri bildirim gönderilemedi',
  feedback_reply_label: 'Platform yanıtı',
  register: 'Kaydol',
  name: 'Ad',
  email: 'E-posta',
  mobile: 'Telefon',
  password: 'Şifre',
  verification_code: 'Doğrulama kodu',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Tüm hakları saklıdır.',
  footerVersion: 'Sürüm {version}',
  copy: 'Kopyala',
  regenerate: 'Yeniden oluştur',
  generate: 'Oluştur',
  contact_now: 'Sohbet et',
  yours: 'senin',
  xiaoyao_analysis: 'Yapay zekâ analizi',
  brand_name: 'OctoSay',
  anonymous: 'Anonim',
  no_summary: 'Özet yok',
  file: 'Dosya',
  discover: 'Keşfet',
  discover_title: 'Keşfet',
  discover_hotChannels: 'Popüler kanallar',
  discover_allChannels: 'Tümü',
  discover_searchChannel: 'Kanal ara',
  discover_noChannels: 'Kanal bulunamadı',

  // Messages
  operationSuccess: 'İşlem başarılı',
  operationFailed: 'İşlem başarısız',
  networkError: 'Ağ hatası, lütfen daha sonra tekrar dene',
  dataLoadingFailed: 'Veriler yüklenemedi',
  noData: 'Veri yok',
  deleteConfirm: 'Silmek istediğine emin misin?',
  saveConfirm: 'Kaydetmek istediğine emin misin?',

  // Form Validation
  required: 'Bu alan zorunludur',
  emailInvalid: 'Geçerli bir e-posta adresi gir',
  phoneInvalid: 'Geçerli bir telefon numarası gir',
  passwordTooShort: 'Şifre en az {min} karakter olmalı',
  passwordMismatch: 'Şifreler eşleşmiyor',

  // Time
  today: 'Bugün',
  yesterday: 'Dün',
  justNow: 'Az önce',
  minutesAgo: '{min} dk önce',
  hoursAgo: '{hour} sa önce',
  daysAgo: '{day} gün önce',

  // Footer
  about: 'Hakkında',
  footerPrivacy: 'Gizlilik Politikası',
  footerTerms: 'Kullanım Koşulları',
  footerSupport: 'Yardım ve destek',

  // Register
  registerAgeConfirm: 'En az 13 yaşında olduğumu onaylıyorum',
  registerAgeConfirm18: '18 yaşından büyük olduğumu onaylıyorum',
  registerTermsPrefix: 'Okudum ve kabul ediyorum: ',
  registerTermsAnd: ' ve ',
  registerAgeError: 'Lütfen yaşını onayla',
  registerTermsError: 'Lütfen koşulları ve gizlilik politikasını kabul et',

  // Chat
  chatPrivacyTip: 'Mesajını grup\'a yaz, yapay zekâ önce seninle sohbet ederek netleştirecek. Onayladıktan sonra mesajın ve yapay zekâ özetin birlikte paylaşılır ve AI eşleştirmeye devam eder.',
  aiChat_quickSuggestions: 'Şunu deneyebilirsin',
  aiChat_welcome: "Selam! Ne aradığını anlat bana.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Detaylar anlaşıldı — eşleşmeni bulmak için paylaş',
  aiChat_readyToPostHint: 'Detay eklemek veya özeti güncellemek için istediğin zaman sohbete devam et',
  aiChat_progressStep1: 'Detayları anla',
  aiChat_progressStep1Done: 'Detaylar anlaşıldı',
  aiChat_progressStep2: 'Yapay zekâ özeti',
  aiChat_progressStep2Desc: "AI eşleşme için bir özet oluşturur",
  aiChat_progressStep3: 'Grup\'a paylaş',
  aiChat_progressStep3Desc: 'Paylaş ve eşleşmeni bul',
  aiChat_publishExtraHint: 'Grup için mesajını gir',
  aiChat_publishMsgRequired: 'Zorunlu',
  aiChat_publishMsgLabel: 'Grup için mesajın',
  aiChat_matchSummaryLabel: 'Yapay zekâ özeti',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'Aşağıdaki içerik yapay zekâ tarafından oluşturulmuştur, yalnızca referanstır.',
  aiChat_publishSuggestionHint: 'Değiştirmek için dokun',
  aiChat_allowDirectContact: 'Doğrudan iletişime izin ver',
  aiChat_allowDirectContactDesc: 'Eşleşme olmadan da başkaları seninle doğrudan iletişime geçebilir',
  channel_chat_session_publishToChannel: 'Octo Grup\'a paylaş',
  aiChat_newChat: 'Sıfırla',

  // Channels / Gruplar
  home_tabChannels: 'Octo Grupları',
  channels_title: 'Octo Grupları',
  channels_myChannels: 'Katıldığın grup\'lar',
  channels_discover: 'Keşfet',
  channels_noChannels: 'Henüz grup yok',
  channels_noMyGroupsTitle: 'Henüz hiçbir grup\'a katılmadın',
  channels_noMyGroupsSubtitle: 'Katılmak için bir grup ara ve bağlantı kurmaya başla',
  channels_searchGroupsBtn: 'Grup ara',
  channels_loginPrompt: 'Grup\'ları görmek için giriş yap',
  channels_create: 'Octo Grup oluştur',
  channels_search: 'Octo Grup ara',
  channels_searchMyGroups: 'Octo Grup\'larımı ara',
  channels_searchHint: 'Ara',
  channels_searchHintChats: 'Sohbetlerde ara...',
  channels_searchHintGroups: 'Grup\'larda ara...',
  channels_searchHintMy: 'Katıldığın grup\'larda ara...',
  channels_joinByCode: 'Kodla katıl',
  channels_joinByCodeTitle: 'Kodla Octo Grup\'a katıl',
  channels_joinByCodeHint: 'Octo Grup kodunu gir',
  channels_joinByCodeConfirm: 'Katıl',
  channels_joinByCodeNotFound: 'Grup bulunamadı',
  channels_createNewGroup: 'Yeni Octo Grup oluştur',
  channels_noResults: 'Grup bulunamadı',
  channel_detail_join: 'Katıl',
  channel_detail_leave: 'Ayrıl',
  channel_detail_members: 'üye',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} gruba katıldı',
  channelJoinMsg_twoJoined: '{name1} ve {name2} gruba katıldı',
  channelJoinMsg_multiJoined: '{name1}, {name2} ve {n} kişi daha gruba katıldı',
  channelJoinMsg_oneAndMoreJoined: '{name} ve {n} kişi daha gruba katıldı',
  channelJoinMsg_membersJoined: '{n} kişi gruba katıldı',

  // Feed
  channels_feed: 'Sohbetler',
  channels_groups: 'Grup\'lar',
  feed_related: 'İlgili',
  feed_recommend: 'Önerilen',
  feed_empty: 'Henüz akış yok, popüler grup\'lara göz at',
  feed_goToGroup: 'Grup\'da gör',
  feed_joinGroupAndSendMsg: 'Bir grup\'a katıl ve mesaj gönder',
  channel_detail_channelCode: 'Octo Grup kodu',
  channel_detail_invitePhrase: '"{name}" grubuna davetlisiniz\nDavet kodu {code} — uygulamayı aç, otomatik katıl · Yapay zekâ önce detayları netleştirir, sonra sana uygun kişileri bulur',
  channel_detail_post: 'Grup\'a paylaş',
  channel_detail_aiHint: "Mesajını grup'a yaz, AI önce detayları netleştirsin",
  channel_input_hint: 'Bir şeyler söyle...',
  channel_leave_confirm_message: 'Bu grup\'dan ayrılmak istediğine emin misin? Artık grup mesajları almayacaksın.',
  channel_invite_notFound: 'Grup bulunamadı veya bağlantının süresi doldu',
  channel_invite_joinBtn: 'OctoSay uygulamasını indir',
  channel_invite_hint: 'Uygulamayı indir, sonra bu QR kodu okut veya grup adını ara ve katıl',
  channel_invite_globalHintTitle: 'Global sürümü indirmek üzeresin',
  channel_invite_globalHintIOS: 'Bu uygulama Çin App Store\'unda bulunmayabilir. Çin dışındaki bir Apple Store\'a geçip OctoSay arayın veya aşağıdan APK\'yı doğrudan indirin.',
  channel_invite_globalHintAndroid: 'Google Play bölgenizde erişilebilir olmayabilir. APK\'yı doğrudan indirmenizi öneririz veya Google Play\'i deneyin.',
  channel_invite_globalHintDefault: 'Uygulama yerel uygulama mağazanızda bulunmayabilir. APK\'yı doğrudan indirmenizi öneririz veya App Store\'u deneyin.',
  channel_invite_globalBtnAppStore: 'App Store\'a git',
  channel_invite_globalBtnGooglePlay: 'Google Play\'e git',
  channel_invite_globalBtnAPK: 'APK\'yı doğrudan indir',
  channel_invite_defaultDesc: 'OctoSay\'daki {name} hübüne katıl',
  share: 'Paylaş',
  share_channel: 'Grup\'ı paylaş',
  share_channel_link: 'Bağlantıyı paylaş',
  channel_detail_inviteCode: 'Davet kodu',
  channel_detail_copyLink: 'Bağlantıyı kopyala',
  share_session_title: 'OctoSay\'da bir gönderi',
  share_match_title: 'OctoSay\'da bir eşleşme',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: '{userName} kullanıcısının OctoSay\'da paylaştıklarına göz at',
  session_share_notFound: 'Gönderi bulunamadı veya bağlantının süresi doldu',
  session_share_fromChannel: 'Octo Grup\'dan',
  session_share_downloadBtn: 'OctoSay uygulamasını indir',
  session_share_hint: 'Gönderinin tamamını görmek ve grup\'a katılmak için uygulamayı indir',
  session_share_openInApp: 'Uygulamada aç',
  toast_link_copied: 'Bağlantı kopyalandı',
  toast_no_share_data: 'Paylaşılacak bir şey yok',
  channels_joinByQR: 'QR kod',
  channels_joinByQRWebHint: 'Web QR okutmayı desteklemiyor. Katılmak için lütfen grup kodunu gir.',
  channels_joinByQRTitle: 'QR kodla katıl',
  channel_detail_qrCode: 'QR kod',
  channel_detail_qrCodeSave: 'Görseli kaydet',
  channel_detail_qrCodeSaveHint: 'Kaydetmek için görsele sağ tıkla',
  channel_detail_qrCodeSaved: 'Albüme kaydedildi',
  channel_detail_qrCodeSaveFailed: 'Kaydedilemedi, tekrar dene',
  channel_detail_locateFailed: 'Mesajın konumu bulunamadı',
  channel_detail_locateError: 'Mesajın konumu aranırken hata oluştu',
  channel_detail_myMessages: 'Mesajlarım',
  channel_detail_searchMessages: 'Mesajlarda ara',
  channel_detail_aiChat: 'AI sohbeti',
  channel_detail_matchHistory: 'Eşleşme geçmişi',
  channel_create_title: 'Octo Grup oluştur',
  channel_create_name: 'Octo Grup adı',
  channel_create_description: 'Açıklama',
  channel_create_submit: 'Oluştur',
  channelCreate_aiAssist: 'AI sana uygun bir grup oluşturmada yardımcı olacak',
  channelCreate_nameHint: 'Grup\'ın için bir ad gir',
  channelCreate_descHint: 'Grup\'ın neyle ilgili olduğunu anlat',
  channelCreate_creating: 'Oluşturuluyor...',
  channelCreate_created: 'Grup oluşturuldu!',
  channelCreate_failed: 'Grup oluşturulamadı',
  channelCreate_welcomeMsg: "Selam! Grup oluşturmana yardımcı olmak için buradayım. Ne tür bir grup istediğini — adını, konusunu veya amacını — söyle, ben de onu grup adı ve grup tanıtımına dönüştürüp avatar oluşturmana yardım edeyim.",
  channelCreate_aiHint: 'Grup\'ının konusunu yaz...',
  channelCreate_clarifyingProgress: 'Grup konun düzenleniyor...',
  channelCreate_readyToCreate: 'Octo Grup oluşturulmaya hazır',
  channelCreate_step1: 'Konuyu anlat',
  channelCreate_step1Done: 'Fikir netleşti',
  channelCreate_step2: 'Octo Grup oluştur',
  channelCreate_confirmBtn: 'Oluşturmayı onayla',
  channelCreate_publicNotice: "Grup'lar, ortak ilgi alanlarına sahip insanların buluşup bağlantı kurduğu herkese açık alanlardır. Platform gerektiğinde grup'ları yönetebilir, güncelleyebilir veya birleştirebilir. Bu grup'ı ilgilenebilecek diğerleriyle paylaşmaktan çekinme.",
  channelCreate_similarGroupsTitle: 'Benzer Octo Grup\'lar bulundu',
  channelCreate_similarGroupsDesc: 'Bu grup\'lar aradığına uygun olabilir',
  channelCreate_exactMatchHint: 'Birebir aynı adda bir grup zaten var!',
  channelCreate_joinHint: 'Bu mevcut grup\'lar sana uygun olabilir',
  channelCreate_joinExisting: 'Mevcut bir Octo Grup\'a katıl',
  channelCreate_stillCreate: 'Yine de yeni Octo Grup oluştur',
  channel_chat_session_comments: 'Yorumlar',
  channel_chat_session_commentHint: 'Bir yorum yaz...',
  channel_chat_session_sendComment: 'Yorum yap',
  channel_chat_session_loadMore: 'Daha fazla yükle',
  channel_chat_session_noComments: 'Henüz yorum yok',
  channel_chat_session_deleteComment: 'Sil',
  channelSearch_title: 'Grup\'da ara',
  channelSearch_placeholder: 'Mesajlarda ara...',
  channelSearch_onlyMine: 'Sadece paylaşımlarım',
  channelSearch_tabAllMessages: 'Grup mesajları',
  channelSearch_tabMyMessages: 'Mesajlarım',
  chatMsgSearch_placeholder: 'Mesajlarda ara',
  chatMsgSearch_tabMsgs: 'Mesajlar',
  chatMsgSearch_tabContacts: 'Kişiler',
  chatMsgSearch_emptyPrompt: 'Mesajlarda aramak için anahtar kelimeler yaz',
  chatMsgSearch_tooShort: 'Aramak için en az 2 karakter yaz',
  chatMsgSearch_contactEmptyPrompt: 'Kişileri aramak için kullanıcı adı veya e-posta yaz',
  chatMsgSearch_noContacts: 'Eşleşen kişi bulunamadı',
  chatMsgSearch_inChatPlaceholder: 'Bu sohbette ara',
  channelHistory_title: 'Geçmiş',
  channelHistory_myMessages: 'Mesajlarım',
  channelHistory_loadMore: 'Daha fazla yükle',
  channel_settings_push: 'Octo Grup bildirimleri',
  channel_settings_commentPush: 'Yorum bildirimleri',
  channel_settings_likePush: 'Beğeni bildirimleri',
  channel_settings_receiveNotifications: 'Bildirimleri al',
  channel_settings_directContact: 'Doğrudan iletişime izin ver',
  session_published: 'Yayınlandı',
  session_publishFailed: 'Paylaşılamadı',
  session_setDirectContactSuccess: 'Ayar kaydedildi',
  session_setDirectContactFailed: 'Ayar kaydedilemedi',
  session_setPrivate: 'Gizli yap',
  session_setPublic: 'Herkese açık yap',
  session_pauseMatching: 'Eşleştirmeyi duraklat',
  session_resumeMatching: 'Eşleştirmeyi sürdür',
  session_matchPausedToast: 'Eşleştirme duraklatıldı',
  session_matchResumedToast: 'Eşleştirme devam ediyor',
  match_matchingPausedTitle: 'Eşleştirme duraklatıldı',
  match_reasonTag: 'Eşleşme nedeni',
  match_matchingPausedHint: 'Eşleştirmeyi istediğiniz zaman yeniden başlatabilirsiniz.',
  session_confirmSetPrivate: 'Bu içerik gizli yapılsın mı? Diğer kullanıcılar göremeyecek.',
  session_messageIsPrivate: 'Bu mesaj gizli',
  chatSessionComment_replyHint: 'Bir yorum yaz...',
  chatSessionComment_reply: 'Yorum',
  chatSessionComment_count: '{n} yorum',
  chatSessionMatch_count: '{n} eşleşme',
  chatSessionComment_replyTo: 'Yanıtla',
  chatSessionComment_inputHint: 'Bir yorum yaz...',
  chatSessionComment_send: 'Gönder',
  chatSessionComment_delete: 'Sil',
  chatSessionComment_deleteConfirm: 'Bu yorumu silmek istediğine emin misin?',
  chatSessionComment_loadMore: 'Daha fazla yükle',
  chatSessionComment_noMore: 'Başka yorum yok',
  chatSessionComment_loginToComment: 'Yorum yapmak için giriş yap',
  chatSessionComment_viewEarlier: 'Önceki {n} yanıtı gör',
  chatSessionLike_like: 'Beğen',
  chatSessionLike_liked: 'Beğendin',
  chatSessionLike_count: 'beğeni',
  chatSessionBookmark_bookmark: 'Kaydet',
  chatSessionBookmark_bookmarked: 'Kaydedildi',
  chatSessionMatch_viewMatches: 'Eşleşmeleri gör',
  chatSessionMatch_matchHistory: 'Eşleşme geçmişi',
  chatSessionMatch_noMatches: 'Henüz eşleşme yok',
  channel_match_achievement: '{count} paylaşım başarıyla eşleşti',
  channel_match_achievement_view: 'Gör →',
  channel_matchHistory_title: 'Kanal eşleşme geçmişi',
  chatSessionMatch_matchedAt: 'Eşleşme zamanı: {time}',
  discover_userMsgLabel: 'Kullanıcı şöyle dedi',
  common_loading: 'Yükleniyor...',
  common_sending: 'Gönderiliyor...',
  common_error: 'Hata',
  common_success: 'Başarılı',
  common_me: 'Ben',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "Yapay zekâ ihtiyacını netleştiriyor, böylece paylaştığın her mesaj işe yarar; paylaşımdan sonra da sana uygun kişileri bulmaya devam eder",
  aiChat_clarifyingAlmostDone: 'Neredeyse bitti, lütfen onayla',
  aiChat_clarifyingOneMore: 'Yaklaşık 1 soru kaldı, sonra paylaşabilirsin',
  aiChat_clarifyingRemaining: 'Yaklaşık {count} tur kaldı, neredeyse bitti',
  aiChat_clarifyingEvaluating: 'İlerleme değerlendiriliyor...',
  aiChat_setPublicMatch: 'Herkese açık yap ve eşleştir',
  aiChat_needsClarifiedPublic: "Artık seni anlıyorum. Onaylayıp yayınladığında AI senin için eşleşme bulmaya devam edecek.\nİstediğin zaman daha fazla detay paylaşabilirsin.",
  aiChat_needsClarifiedPrivate: 'Anladım! Herkese açık yap, ben de senin için eşleşme bulmaya devam edeyim!\nDetayları istediğin zaman anlatabilirsin.',
  aiChat_setPublicTitle: 'Herkese açık yap',
  aiChat_setPublicMessage: 'İçeriğin başkaları tarafından görülebilir olacak, böylece OctoSay sana uygun eşleşmeler bulabilir.\n\nPaylaşılacak bilgiler:\n• Kullanıcı adın ve profil fotoğrafın\n• İçeriğinin özeti\n• Sohbet içeriği (Keşfet sekmesinde görünür)\n\nİstediğin zaman tekrar gizli yapabilirsin.',
  aiChat_findMatches: 'Eşleşme sonucunu gör',
  aiChat_publishing: 'Gönderiliyor...',
  aiChat_matchSectionTitle: 'Mesajın en çok bu gruplara uyuyor — yayınlamak için dokun',
  aiChat_joinedBadge: 'Üyesin',
  aiChat_matchSectionEmpty: 'Henüz uygun grup yok — yeni bir grup oluşturup oraya paylaşabilirsin',
  aiChat_suggestPublishCreateNew: 'Yeni grup oluştur',
  aiChat_repickChannel: 'Grubu değiştir',
  aiChat_creatingChannelTitle: 'Uygun grup bulunamadı — senin için oluşturuluyor',
  aiChat_creatingChannelHint: 'Yapay zekâ isteğine göre grup oluşturuyor, sonra doğrudan paylaşuma geçeceksin — genelde 10-30 saniye',
  aiChat_publishToChannelHint: '"{name}" grubuna paylaşılacak',
  aiChat_pickChannelTitle: 'Yayınlayacağın grubu seç',
  aiChat_matchingChannelTitle: 'Senin için doğru grup aranıyor',
  aiChat_matchingChannelHint: 'Yapay zekâ isteğine göre arıyor — genellikle birkaç saniye ile yarım dakika sürer',
  aiChat_matchUnavailableTitle: 'Öneriler kullanılamıyor',
  aiChat_matchUnavailableHint: 'Aşağıdan grup arayın veya kapatıp yeniden açın',
  aiChat_waitSlowHint: 'Normalden uzun sürüyor ama işlem devam ediyor — biraz daha bekleyin veya aşağıdan grup arayın',
  aiChat_creatingSlowHint: 'Grup oluşturma normalden uzun sürüyor ama işlem devam ediyor — ardından doğrudan paylaşuma geçeceksin',
  aiChat_pickChannelEmptyHint: 'İlgili grup bulunamadı. Mesajını paylaşmak için yeni bir grup oluştur',
  aiChat_loadMore: 'Daha Fazla Yükle',
  sidebar_publish: 'Gönder',
  chat_selectLocationOnMap: 'Lütfen haritada bir konum seç',

  // App.vue new
  placeholder_email: 'E-posta gir',
  placeholder_mobile: 'Telefon numarası gir',
  placeholder_password: 'Şifre gir',
  placeholder_name: 'Adını gir',
  random_nickname: 'Rastgele',
  placeholder_verification_code: 'Doğrulama kodunu gir',
  sending: 'Gönderiliyor...',
  registering: 'Kaydolunuyor...',
  send_code: 'Kod gönder',
  retry_in_seconds: '{countdown} sn sonra tekrar dene',
  toast_enter_email: 'Lütfen e-posta gir',
  toast_enter_mobile: 'Lütfen telefon numarası gir',
  toast_invalid_email: 'Lütfen geçerli bir e-posta biçimi gir',
  toast_invalid_mobile: 'Lütfen geçerli bir telefon numarası gir',
  toast_send_code_failed: 'Doğrulama kodu gönderilemedi',
  toast_code_sent: 'Doğrulama kodu e-postana gönderildi',
  toast_code_sent_sms: 'Doğrulama kodu telefonuna gönderildi',
  toast_send_code_error: 'Doğrulama kodu gönderilemedi, lütfen daha sonra tekrar dene',
  toast_fill_all_fields: 'Lütfen tüm alanları doldur',
  toast_login_failed: 'Giriş yapılamadı',
  toast_login_success: 'Giriş başarılı',
  oauthOr: 'veya',
  toast_oauth_login_failed: 'Google ile giriş yapılamadı',
  toast_oauth_login_error: 'Google girişinde hata oluştu, tekrar dene',
  toast_login_error: 'Giriş yapılamadı, lütfen daha sonra tekrar dene',
  toast_register_failed: 'Kaydolunamadı',
  toast_register_success: 'Kaydolma başarılı',
  toast_register_error: 'Kaydolunamadı, lütfen daha sonra tekrar dene',

  // AdBanner.vue
  ad: 'Reklam',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Bağlanmadan önce',
  contactAd_gateSubtitle: 'Bu kısa ara OctoSay\'ı ücretsiz tutuyor — desteğin için teşekkürler!',
  contactAd_waitBtn: '{sec} sn sonra devam edebilirsin',
  contactAd_continueBtn: 'Sohbete devam et',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Sohbet',

  // AiMatch.vue
  ai_welcome_msg: 'Merhaba, ben AI. Aklından geçeni anlat — bir yol arkadaşı, partner, beceri takası ya da HERHANGİ bir şey.',
  default_username: 'Kullanıcı',

  // AvatarCropDialog.vue
  crop_hint: 'Yakınlaştırmak için iki parmakla aç, ayarlamak için sürükle',
  toast_crop_failed: 'Görsel kırpılamadı',

  // ChatBox.vue
  loading_match_info: 'Eşleşme bilgisi yükleniyor...',
  view_match_details: 'Eşleşme detaylarını gör',
  step_clarify_needs: 'Netleştir',
  step_ai_matching: 'Grup\'a paylaş',
  step_connect: 'Yapay zekâ eşleşmesi',
  make_private: 'Gizli yap',
  setting: 'Ayarlanıyor...',
  action_photo: 'Fotoğraf',
  action_file: 'Dosya',
  action_video: 'Video',
  action_location: 'Konum',
  hint_get_app: 'Bağlantıda kalmak için uygulamayı al',
  match_finding_title: 'Eşleşmelerin',
  match_finding_subtitle: 'AI senin için eşleşme bulmaya devam ediyor',
  match_time_hint: 'Bu işlem genellikle 1-2 dakika sürer',
  match_result_stats: '{matched} en iyi eşleşme bulundu{interested}',
  match_tap_to_connect: 'Sohbetini başlatmak için dokun',
  match_channel_hint: '<strong>#{channel}</strong> grup\'ında eşleştirme yapılıyor. Aynı grup önceliklidir, gerektiğinde diğer grup\'lar da dahil edilebilir.',
  label_perfect_match: 'En iyi eşleşme',
  label_worth_a_look: 'Göz atmaya değer',
  match_no_result_title: 'Senin için eşleşmeye devam ediyoruz',
  match_no_result_desc: 'OctoSay\'ın doğru eşleşmeleri bulmasına yardımcı olmak için daha fazla detay paylaş. Birisi seninle eşleştiğinde bildirim almak için uygulamayı yükle.',
  go_back: 'Geri',
  no_public_requirements: 'Henüz herkese açık paylaşım yok',
  channelEmpty_title: 'Burada henüz sessizlik var',
  channelEmpty_subtitle: 'Düşüncelerini paylaşan ilk kişi ol',
  channelEmpty_hint: "Fikirlerini yaz, AI detayları netleştirmene yardım etsin ve eşleşmeye devam etsin, mesajın kaybolmasın",
  channelEmpty_action: 'Düşüncelerini paylaş',
  stay_connected: 'Bağlantıda kal',
  download_app_desc: 'Uygulamayı al, sohbet et ve seninle iletişime geçildiğinde anında bildirim al!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'Doğrudan APK',
  match_history: 'Eşleşme geçmişi',
  no_match_history: 'Henüz eşleşme geçmişi yok',
  finding_matches: 'AI eşleşme bulmaya devam ediyor - Bir grup\'a mesaj paylaştıktan sonra',
  discover_connect_hint: 'Eşleştiğinde onlarla sohbet edebilirsin!',
  match_initializing: 'Başlatılıyor...',
  placeholder_login_to_chat: 'giriş yap ve aklından geçeni anlat',
  toast_need_clear: 'Fikrin netleşti!',
  toast_ai_responding: 'AI yanıtlıyor, lütfen bekle...',
  toast_uploading_image: 'Görsel yükleniyor, lütfen bekle...',
  toast_uploading_file: 'Dosya yükleniyor, lütfen bekle...',
  toast_max_photos: 'En fazla {max} fotoğraf yüklenebilir',
  toast_uploading: 'Yükleniyor, lütfen bekle...',
  toast_file_too_large: '{name} 5MB sınırını aşıyor',
  toast_video_too_large: '{name} 20MB sınırını aşıyor',
  toast_video_processing: 'Video işleniyor, lütfen bekle...',
  toast_upload_link_failed: 'Yükleme bağlantısı alınamadı',
  analyzing_image: 'Görsel analiz ediliyor...',
  toast_location_confirmed: 'Konum onaylandı',
  toast_location_selected: 'Konum seçildi',
  toast_enter_search: 'Lütfen aranacak içeriği gir',
  toast_search_failed: 'Arama başarısız',
  toast_no_locations: 'Konum bulunamadı',
  toast_search_error: 'Arama başarısız, tekrar dene',
  toast_located_at: 'Bulunan konum: {address}',
  toast_shared_finding: 'Paylaşıldı! Eşleşmeler aranıyor...',
  toast_update_failed: 'Güncelleme başarısız',
  toast_set_private: 'Gizli yapıldı',
  toast_no_matches: 'Eşleşme bulunamadı',
  toast_matches_found: '{count} en iyi eşleşme bulundu',
  toast_start_conversation_first: 'Önce bir sohbet başlat',
  toast_load_history_failed: 'Eşleşme geçmişi yüklenemedi',
  toast_ai_timeout: 'AI zaman aşımına uğradı, tekrar dene',
  toast_message_blocked: 'Mesaj engellendi',
  network_disconnected: 'Ağ bağlantısı kesildi',
  toast_publish_success: 'Grup\'a paylaşıldı!',
  toast_publish_failed: 'Grup\'a paylaşılamadı',

  // ChatMsgList.vue
  collapse_thinking: 'düşünme sürecini kapat',
  expand_thinking: 'düşünme sürecini aç',
  thinking: 'düşünüyor',
  select_date: 'Tarih seç',
  selected_location: 'Seçilen konum',
  msg_blocked: 'Engellendi',
  retry: 'Tekrar dene',
  msg_read: 'Okundu',
  msg_sent: 'Gönderildi',
  msg_unread: 'Okunmadı',
  label_start_datetime: 'Başlangıç tarihi ve saati:',
  label_end_datetime: 'Bitiş tarihi ve saati:',
  toast_select_start_datetime: 'Lütfen başlangıç tarihi ve saatini seç',
  toast_end_before_start: 'Bitiş tarihi/saati başlangıçtan önce olamaz',
  report_message: 'Mesajı bildir',
  block_user: 'Kullanıcıyı engelle',
  msg_revoke: 'Geri al',
  msg_quote: 'Alıntıla',
  msg_revoked_self: 'Bir mesajı geri aldın',
  msg_revoked_other: 'Karşı taraf bir mesajı geri aldı',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Mesaj geri alındı',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'Bu mesaj kurallara aykırı olduğu için platform tarafından geri çekildi',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Mesaj geri alındı',
  toast_revoke_failed: 'Mesaj geri alınamadı',
  toast_load_data_failed: 'Veriler yüklenemedi, lütfen sayfayı yenile.',
  toast_file_url_missing: 'Dosya bağlantısı bulunamadı',
  toast_block_success: 'Kullanıcı başarıyla engellendi',
  toast_block_failed: 'Kullanıcı engellenemedi',

  // ChatSession.vue
  no_more_records: 'başka kayıt yok.',
  title_needs_clarified: 'Düşünceler netleşti',
  title_clarifying: 'Düşüncelerin netleştiriliyor',
  title_public: 'Herkese açık',
  title_private: 'Gizli',
  badge_clarified: 'Netleşti',
  badge_clarifying: 'Netleştiriliyor',
  badge_only_me: 'Sadece ben',
  badge_expired: 'Süresi doldu',
  title_expired: 'Süresi doldu',
  no_chat_history: 'Sohbet geçmişi yok',

  // ContactMethods.vue
  block_status_banner: 'Bu kullanıcıyı engelledin',
  unblock_user: 'Engeli kaldır',
  toast_block_missing_id: 'Engellenemedi: kullanıcı ID\'si eksik',
  dialog_block_confirm: '{name} kullanıcısını engellemek istediğine emin misin? Bu kişiden hiçbir mesaj almayacaksın.',
  toast_user_blocked: '{name} engellendi',
  toast_unblock_missing_id: 'Engel kaldırılamadı: kullanıcı ID\'si eksik',
  toast_user_unblocked: '{name} kullanıcısının engeli kaldırıldı',

  // BlockedUsers.vue
  blocked_users: 'Engellenen kullanıcılar',
  blocked_users_empty: 'Engellenen kullanıcı yok',
  blocked_users_empty_hint: 'Engellediğin kullanıcılar sana mesaj gönderemeyecek',
  blocked_users_unblock: 'Engeli kaldır',
  dialog_unblock_confirm: 'Engel kaldırıldığında, bu kişi sana tekrar mesaj gönderebilecek.',
  toast_unblock_success: 'Engel kaldırıldı',
  toast_unblock_failed: 'Engel kaldırılamadı, tekrar dene',
  blocked_users_load_failed: 'Yüklenemedi. Tekrar denemek için dokun',
  blocked_users_blocked_at: 'Engellendi {date}',
  blocked_users_unknown_user: 'Bilinmeyen kullanıcı',

  // Contacts.vue
  no_connections: 'Henüz mesaj yok',
  chat_with: '{name} ile sohbet et',
  toast_load_contacts_failed: 'Kişiler yüklenemedi: {msg}',
  toast_load_contacts_error: 'Kişiler yüklenemedi. Lütfen yenile ve tekrar dene.',
  time_just_now: 'Az önce',
  time_minutes_ago: '{min} dk önce',
  time_hours_ago: '{hour} sa önce',
  time_days_ago: '{day} gün önce',

  // InteractionNotification.vue
  interaction_notification_title: 'Bildirimler',
  interaction_notification_subtitle: 'Yorumlar ve beğeniler',
  interaction_notification_empty: 'Henüz bildirim yok',
  interaction_notification_comment: 'yorum yaptı: {content}',
  interaction_notification_like: 'gönderini beğendi',
  interaction_notification_reply: 'yanıtladı: {content}',
  interaction_notification_bookmark: 'gönderini kaydetti',
  toast_load_notifications_failed: 'Bildirimler yüklenemedi: {msg}',
  toast_load_notifications_error: 'Bildirimler yüklenemedi. Lütfen yenile ve tekrar dene.',
  mark_all_read: 'Tümünü okundu işaretle',
  toast_mark_all_read_failed: 'İşlem başarısız, tekrar dene',
  contacts_dnd: 'Bildirimleri sustur',
  dnd_enabled: 'Bildirimler susturuldu',
  dnd_disabled: 'Bildirimler açıldı',
  dnd_action_enable: 'Bildirimleri sustur',
  dnd_action_disable: 'Bildirimleri aç',

  // Discover.vue
  toast_load_sessions_failed: 'Oturumlar yüklenemedi: {msg}',
  toast_load_sessions_error: 'Oturumlar yüklenemedi',
  discover_noMessages: 'Henüz mesaj yok',

  // EmojiInputArea.vue
  placeholder_default: 'AI ile daha fazla detay paylaş',
  userChat_typeMessage: 'Bir mesaj yaz...',
  select_emoji: 'Emoji seç',
  badge_new: 'yeni',
  channel_search_placeholder: 'Kanal gir',
  channel_picker_empty: 'Kanal gir',

  // FrontPage.vue
  tab_chat_with_ai: 'OctoSay seni anlasın',
  history_chats: 'Geçmiş',
  tab_connections: 'Eşleşmeler',
  tab_conversations: 'Mesajlar',
  tab_profile: 'Profil',
  new_session: 'Yeni',
  history_tab_chats: 'Benimkiler',
  history_tab_matches: 'Eşleşmeler',
  channels_octosay: 'Octo Grupları',
  tab_matches: 'Eşleşmeler',
  tab_messages: 'Mesajlar',

  // Header.vue
  slogan: 'OctoSay - Seni anlayan ve seni doğru kişiyle buluşturan yapay zekâ',
  app_name: 'OctoSay',
  slogan_short: 'Seni anlayan ve seni doğru kişiyle buluşturan yapay zekâ',
  slogan_ai: 'Seni anlayan ve seni doğru kişiyle buluşturan yapay zekâ',
  get_the_app: 'Uygulamayı al',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'veya uygulama mağazalarında OctoSay ara',

  // MapLocationPicker.vue
  placeholder_search_location: 'Konum ara...',
  coords_display: 'Boylam: {lng}, Enlem: {lat}',
  toast_no_geolocation: 'Tarayıcın coğrafi konumu desteklemiyor',
  toast_location_permission_denied: 'Konumun alınamadı, lütfen konum izinlerini kontrol et',
  loading_address: 'Adres yükleniyor...',

  // MatchedSession.vue
  created_at: 'Oluşturuldu: {time}',
  ai_match_analysis: 'AI eşleşme analizi',
  error_missing_session_params: 'Gerekli oturum parametreleri eksik',
  match_private_hint: 'Bu oturum gizli. İçerik kullanılamıyor',

  // PersonalCenter.vue
  label_name: 'Ad:',
  placeholder_enter_name: 'Adını gir',
  label_bio: 'Hakkında:',
  placeholder_enter_bio: 'Kendinle ilgili bir şeyler yaz',
  placeholder_bio_empty: 'Kendinle ilgili bir şeyler anlat',
  bio: 'Hakkında',
  delete_account: 'Hesabı sil',
  delete_warning: 'Bu işlem geri alınamaz.',
  delete_data_intro: 'Aşağıdaki veriler kalıcı olarak silinecek:',
  delete_item_profile: 'Profil bilgilerin',
  delete_item_chat: 'Sohbet geçmişi ve oturumlar',
  delete_item_contact: 'Kişi bilgileri',
  delete_item_all: 'Tüm ilgili veriler',
  final_confirmation: 'Son onay',
  delete_confirm_prompt: 'Onaylamak için "delete" yaz:',
  placeholder_type_delete: 'delete yaz',
  private_token: 'Özel jeton',
  token_desc: 'API erişimi için jeton oluştur',
  toast_not_logged_in: 'Kullanıcı giriş yapmamış',
  toast_name_required: 'Ad zorunludur',
  toast_save_success: 'Başarıyla kaydedildi',
  toast_save_failed: 'Kaydedilemedi',
  toast_image_too_large: 'Görsel 5MB sınırını aşıyor',
  toast_avatar_updated: 'Profil fotoğrafı güncellendi',
  toast_avatar_failed: 'Profil fotoğrafı güncellenemedi',
  toast_upload_failed: 'Yükleme başarısız',
  toast_token_generated: 'Jeton oluşturuldu',
  toast_token_failed: 'Jeton oluşturulamadı',
  toast_copied: 'Panoya kopyalandı',
  toast_copy_failed: 'Kopyalanamadı',
  toast_account_deleted: 'Hesap başarıyla silindi',
  toast_delete_account_failed: 'Hesap silinemedi',
  toast_logout_success: 'Çıkış başarılı',
  toast_logout_failed: 'Çıkış yapılamadı',
  profile_tab_messages: 'Mesajlar',
  profile_tab_comments: 'Yorumlar',
  profile_tab_likes: 'Beğeniler',
  profile_tab_bookmarks: 'Kaydedilenler',
  profile_empty_messages: 'Henüz mesaj yok',
  profile_empty_comments: 'Henüz yorum yok',
  profile_empty_likes: 'Henüz beğeni yok',
  profile_empty_bookmarks: 'Henüz kaydedilen yok',
  profile_reply_to: '{name} kullanıcısına yanıt',
  profile_stats_posts: 'Mesajlar',
  profile_stats_comments: 'Yorumlar',
  profile_stats_likes: 'Alınan beğeniler',
  profile_joined: 'Katıldı: {date}',

  // ReportDialog.vue
  report_message_title: 'Mesajı bildir',
  report_reason_prompt: 'Bu mesajı bildirmek için bir neden seç:',
  report_spam: 'Spam',
  report_harassment: 'Taciz veya zorbalık',
  report_inappropriate: 'Uygunsuz içerik',
  report_other: 'Diğer',
  placeholder_report_desc: 'Sorunu anlat (isteğe bağlı)',
  toast_select_reason: 'Lütfen bir neden seç',
  toast_report_success: 'Bildirim başarıyla gönderildi',
  toast_report_failed: 'Bildirim gönderilemedi',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Görsel]',
  summary_images: '[Görsel x{count}]',
  summary_file: '[Dosya]',
  summary_files: '[Dosya x{count}]',
  summary_video: '[Video]',
  summary_videos: '[Video x{count}]',
  summary_location: '[Konum]',
  summary_locations: '[Konum x{count}]',
  summary_emoji: '[Emoji]',
  summary_emojis: '[Emoji x{count}]',
  summary_voice: '[Sesli mesaj]',
  summary_voices: '[Sesli mesaj x{count}]',
  summary_mixed: '[Karışık]',
  summary_other: '[Diğer]',

  // Voice messages
  voice: 'Sesli mesaj',
  voice_recording: 'Kaydediliyor...',
  toast_voice_too_short: 'Kayıt çok kısa',
  toast_voice_failed: 'Sesli mesaj gönderilemedi',
  toast_mic_permission_denied: 'Mikrofona erişilemiyor. Lütfen tarayıcı ayarlarından etkinleştir',
  toast_recording_not_supported: 'Bu tarayıcı sesli kaydı desteklemiyor',
  voice_load_failed: 'Sesli mesaj yüklenemedi',

  // Expire At
  aiChat_expireLine: "{date} tarihine kadar geçerli, güncellemek için AI'ya istediğin zaman söyle",
  aiChat_expireExpired: "İçeriğin süresi doldu ve artık başkaları tarafından görüntülenemiyor. Süresini güncellemek için AI'ya istediğin zaman söyle",

  // MatchedSession.vue
  detail: 'Detay',

  // Match notification hints
  match_new_result_hint: 'Daha sonra yeni eşleşme sonuçları çıkarsa e-postayla bilgilendirilirsin. Daha iyi bir deneyim için uygulamayı yükle ve anında bildirim al.',

  // Match notification hints
  match_connection_notify_hint: 'Eşleşme yapıldı ve bildirildi! Hadi merhaba de!',
  match_continuousMatching: "AI senin için sürekli eşleşme arıyor",
  match_continuousMatchingHint: 'Yeni eşleşmeler bulunur bulunmaz haber vereceğiz',
  match_continuousMatchingOthers: "AI onlar için sürekli eşleşme arıyor",
  match_continuousMatchingOthersHint: 'Yeni eşleşmeler bulundukça burada görünecek',
  match_noResultsTitleOthers: 'Bu kişi için eşleşmeye devam ediliyor',
  match_noResultsHintOthers: "AI onlar için sürekli eşleşme arıyor. Sonuçlar bulunduğunda burada görünecek.",
  match_newMatchFound: '{n} yeni eşleşme bulundu!',
  match_worth_exploring_hint: 'İlk adımı atıp atmamaya sen karar ver.',

  // Matches filter tags
  filter_all: 'Tümü',
  filter_best_connection: 'En iyi eşleşme',
  filter_worth_a_look: 'Göz atmaya değer',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - Seni anlayan ve seni doğru kişiyle buluşturan yapay zekâ',
  landing_hero_title: 'Grup\'ına yaz — AI önce netleştirir, sonra sen paylaşırsın ve eşleşirsin.',
  landing_hero_subtitle: 'Paylaşmak istediğin mesajı bir Octo Grup\'a yaz. Yayınlanmadan önce AI seninle sohbet edip detayları netleştirir. Onayladıktan sonra mesajın ve yapay zekâ özetin birlikte paylaşılır ve AI eşleştirmeye başlar.',
  landing_download_on: 'İndir:',
  landing_get_it_on: 'Edin:',
  landing_direct_download: 'Doğrudan indir',
  landing_how_title: 'Nasıl çalışır',
  landing_step1_title: 'Grup\'a yaz',
  landing_step1_desc: 'Paylaşmak istediğin mesajı grup\'a yaz. Yapay zekâ önce seninle sohbet ederek detayları netleştirir; böylece her paylaşım net, faydalı ve eşleşmeye hazır olur — gürültüde kaybolmaz.',
  landing_step2_title: 'Onayla, paylaş ve eşleş',
  landing_step2_desc: 'Onayladığında orijinal mesajın ve yapay zekâ özeti birlikte grup\'a paylaşılır. Ardından yapay zekâ senin için en iyi eşleşmeleri aramaya devam eder; böylece mesajın gömülüp görmezden gelinmez.',
  landing_step3_title: 'Bağlan ve sohbet et',
  landing_step3_desc: 'Eşleşme oluştuğunda her iki taraf da birbirinin AI ile olan sohbet geçmişini ve yapay zekâ özetini görebilir. Ortak bir bağlam olduğundan buz kırma kolaydır — sadece doğal bir şekilde sohbet edin.',
  // Comparison Section
  landing_comparison_title: 'Neden OctoSay?',
  landing_comparison_subtitle: 'Grup usulü sohbet, ama AI detaylarını netleştirir ve seni aktif olarak eşleştirir.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'İçerik kalitesi',
  landing_cmp1_other: 'Spam, reklam ve konu dışı mesaj seli',
  landing_cmp1_octo: 'Sadece yapay zekâ seçilmiş ihtiyaç kartları',
  landing_cmp2_label: 'İnsan bulmak',
  landing_cmp2_other: 'Paylaş ve sadece cevap bekle',
  landing_cmp2_octo: 'AI seni aktif olarak eşleştirir',
  landing_cmp3_label: 'Gürültü seviyesi',
  landing_cmp3_other: 'Kaydırılacak yüzlerce mesaj',
  landing_cmp3_octo: 'Sıfır gürültü, her paylaşım önemli',
  landing_cmp4_label: 'Başlangıç',
  landing_cmp4_other: 'Sunucu bul, kanalları gez, kendin çözmeye çalış',
  landing_cmp4_octo: 'Grup\'a yaz; AI netleştirir ve eşleştirir',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Grup sohbetleri reklam ve spam dolar',
  landing_cmp1_xhs: 'Her yer tanıtım gönderisi, güvenmesi zor',
  landing_cmp1_facebook: 'Reklamlar ve tıklama tuzağı akışını doldurur',
  landing_cmp1_reddit: 'Spam ve konu dışı gönderiler her yerde',
  landing_cmp2_wechat: 'Sadece kişiler ve grup davetleriyle',
  landing_cmp2_xhs: 'Kendin ararsın ve gönderileri didiklersin',
  landing_cmp2_facebook: 'Mevcut arkadaş ve gruplarla sınırlı',
  landing_cmp2_reddit: 'Subreddit\'leri kendin gezersin ve cevap umarsın',
  landing_cmp3_wechat: 'Yüzlerce grup mesajını kaydırırsın',
  landing_cmp3_xhs: 'Akış öneri ve reklam kaynıyor',
  landing_cmp3_facebook: 'Önerilen gönderiler ve reklamlar bitmez',
  landing_cmp3_reddit: 'Kaydırılacak yüzlerce yorum',
  landing_cmp5_label: 'Kim arıyor',
  landing_cmp5_wechat: 'Tek tek sorarsın, şansını denersin',
  landing_cmp5_xhs: 'Paylaşırsın, yorum beklersin, kendin elersin',
  landing_cmp5_facebook: 'Gruplarda şuraya buraya sorman gerekir',
  landing_cmp5_reddit: 'Paylaşırsın, cevap beklersin, sonra elersin',
  landing_cmp5_octo: 'Yapay zekâ senin için otomatik olarak sürekli insan bulur',

  landing_features_title: 'Temel özellikler',
  landing_feature1_title: 'Paylaşmadan önce netleştir',
  landing_feature1_desc: 'Doldurulacak form yok. Mesajını grup\'a yaz, AI önce seninle sohbet edip doğru soruları sorar ve neye ihtiyacın olduğunu gerçekten anlar.',
  landing_feature2_title: 'Temiz, dağınık değil',
  landing_feature2_desc: 'Mesajın ve yapay zekâ özeti birlikte paylaşılır — OctoSay her paylaşımı özenle seçer; spam yok, konu dışı sel yok, kaydırılacak gürültü yok.',
  landing_feature3_title: 'Etkin eşleştirme',
  landing_feature3_desc: 'Onayladıktan ve mesajın + yapay zekâ özeti yayına girdikten sonra, AI grup\'ı sürekli tarar ve aradığına uyan kişileri bulur — ve nedenini açıklar.',
  landing_feature4_title: 'Konu toplulukları, sıfır gürültü',
  landing_feature4_desc: 'Konu grup\'larına katıl — spor, oyun, dil değişimi, ev arkadaşı — AI paylaşmadan önce mesajını netleştirir; böylece her grup temiz ve faydalı kalır.',
  landing_feature5_title: 'Gizlilik korunur',
  landing_feature5_desc: 'Gönderdikten sonra mesajları gizli yapabilirsin, sadece sen görürsün. Tam kontrol.',
  landing_feature6_title: 'Anlamlı sohbetler',
  landing_feature6_desc: 'Gürültü yok, dağınıklık yok — her mesajın bir değeri var.',
  landing_usecases_title: 'Her senaryoya uyar',
  landing_usecases_subtitle: 'Aklında ne olursa olsun, konu grup\'ına katıl — eşleştirmeyi AI halleder, kaydırıp aramana gerek kalmaz',
  landing_usecase_game: 'Oyun arkadaşı',
  landing_usecase_language: 'Dil değişimi',
  landing_usecase_skill: 'Beceri takası',
  landing_usecase_roommate: 'Ev arkadaşı bul',
  landing_usecase_travel: 'Seyahat arkadaşı',
  landing_usecase_sports: 'Spor arkadaşı',
  landing_usecase_study: 'Ders arkadaşı',
  landing_usecase_anything: '...ya da her şeyi paylaş',
  landing_cta_title: 'Başlamaya hazır mısın?',
  landing_cta_desc: 'Bir konu grup\'ına katıl, paylaşmak istediğini yaz, AI detayları netleştirsin, sonra paylaş ve doğru kişilerle eşleş.',
  landing_use_now: 'Hemen kullan',
  landing_groups: 'Grup\'lar',

  // OnboardingPage.vue
  onboarding_skip: 'Atla',
  onboarding_next: 'İleri',
  onboarding_getStarted: 'Başla',
  onboarding_step1Title: "Grubta ne istediğini söyle",
  onboarding_step1Desc: "Ne aradığını veya ne yapmak istediğini doğrudan söyle. Yapay zekâ detayları netleştirmek için seninle sohbet eder ve sözünü herkesin anlayacağı net bir ihtiyaca dönüştürür.",
  onboarding_step2Title: 'Onayla, paylaş ve eşleş',
  onboarding_step2Desc: "Mesajın grup'a yayınlandığında, yapay zekâ en iyi eşleşmelerini sürekli bulur; mesajın gömülüp görmezden gelinmez.",
  onboarding_step3Title: 'Bağlan ve sohbet et',
  onboarding_step3Desc: "İki taraf da birbirinin AI ile olan sohbetini görebilir ve ne aradığını bilir. Ortak bağlamla buzları kırmak çok kolay — doğal bir şekilde sohbet etmen yeterli.",

  // ChannelDetail.vue
  channel_image_limit: 'En fazla 1 görsel',

  // ChannelMembers.vue
  channel_members_empty: 'Henüz üye yok',
  channel_members_title: 'Üyeler',
  channel_role_owner: 'Sahibi',
  channel_role_admin: 'Yönetici',
  channel_role_member: 'Üye',

  // Settings.vue
  settings_language: 'Dil',
  settings_language_followSystem: 'Sistem ayarına göre',

  // ChatBox.vue
  match_interested_suffix: ', {count} tanesi göz atılmaya değer',

  // ChatBox.vue - AI eşleştirme ilerleme aşamaları
  match_stage_fetch_chat: 'Konuşma alınıyor',
  match_stage_query_expansion: 'Sorgular genişletiliyor',
  match_stage_semantic_search: 'Anlamsal arama',
  match_stage_deep_search: 'Derin analiz',
  match_stage_rerank: 'Akıllı eşleştirme',
  match_stage_refining: 'Sonuçlar optimize ediliyor',
  match_stage_fetch_details: 'Detaylar alınıyor',

  // ChannelDetail.vue - Resim yükleme
  channel_select_image: 'Lütfen bir resim dosyası seçin',
  channel_image_upload_failed: 'Resim yüklenemedi, lütfen tekrar deneyin',
  chatInput_channelSearchHint: "Grup ara",
}



// WEBPACK FOOTER //
// ./src/i18n/tr.js